import avAnalyticsFormSubmit from '@/utils/directives/avAnalyticsFormSubmit';
import avAnalyticsCtaInteraction from '@/utils/directives/avAnalyticsCtaInteraction';

export default {
  install(Vue) {
    Vue.directive('av-analytics-form-submit', avAnalyticsFormSubmit);
    Vue.directive('av-analytics-cta-interaction', avAnalyticsCtaInteraction);
  },
};
